import React, { memo } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import cx from 'clsx';

import { COUPON, type DiscountVariant } from '../../promotional-price/promotional-price';
import { messages } from './messages';
import styles from './shipment-tier-marker.module.less';

type ShipmentTierMarkerProps = {
  discountPercent: number;
  variant: DiscountVariant;
};

export const ShipmentTierMarker = memo(({ discountPercent, variant }: ShipmentTierMarkerProps) => (
  <span className={cx(styles.marker, variant === COUPON ? styles.coupon : styles.promo)}>
    <FormattedMessage
      {...messages.percentOff}
      values={{ percent: <FormattedNumber maximumFractionDigits={0} style='percent' value={discountPercent / 100} /> }}
    />
  </span>
));
